import { Icon } from 'antd';
import React, { memo, useCallback, useState } from 'react';
import DropdownRender from '../../../../components/select/DropdownRender/DropdownRender';
import useDebouncedSearch from '../../../../hooks/useDebouncedSearch';
import useSearchParamsState from '../../../../hooks/useSearchParamsState';
import usePeople from '../../queries/usePeople';

const FilterCell = memo(({ text, paramKey }) => {
  const [_search, setSearch, debouncedSearch] = useDebouncedSearch();
  const { data: peopleList, loading: peopleListLoading } =
    usePeople(debouncedSearch);
  const [dropdownOpened, setDropdownOpened] = useState(false);
  const [selected, setSelected] = useSearchParamsState(
    paramKey,
    [],
    parseParams,
    'brackets'
  );
  const closeDropdown = useCallback(() => setDropdownOpened(false), []);
  const openDropdown = useCallback(() => setDropdownOpened(true), []);
  return (
    <span
      onClick={openDropdown}
      style={{
        position: 'relative',
        cursor: 'pointer',
      }}
    >
      {text} <Icon type="filter" theme={!!selected.length && 'filled'} />
      {dropdownOpened && (
        <DropdownRender
          searchRequest={setSearch}
          options={peopleList}
          setState={setSelected}
          selected={selected}
          closeDropdown={closeDropdown}
          textField={'fullName'}
          loading={peopleListLoading}
        />
      )}
    </span>
  );
});



function parseParams(array) {
  return array.map((value) => Number(value));
}
export default FilterCell;
